import React from "react";
import { useNavigate } from "react-router-dom";
import { Col, Row, Tooltip, Card , Divider, notification } from "antd";
import { InfoCircleOutlined, ArrowRightOutlined, LoadingOutlined } from "@ant-design/icons";
import "./LandingPage.scss";
import LandingPageHeader from "../../assets/icons/landing-page-header.svg";
import { ReactComponent as Icon1 } from "../../assets/icons/landing-page-icon-1.svg";
import { ReactComponent as Icon2 } from "../../assets/icons/landing-page-icon-2.svg";
import { logout } from "../../services/ExperienceBankAPI";
import LillyIcon from "../../assets/icons/Lilly-logo.svg";
import GileadIcon from "../../assets/icons/Gilead-logo.svg";
import ZSLogo from "../../assets/icons/zs-logo.svg";
import JJIcon from "../../assets/icons/johnson-johnson-logo.svg";
import SanofiIcon from "../../assets/icons/sanofi-landing-logo.svg";
import AZIcon from "../../assets/icons/az-logo-white.png";
import NovartisIcon from "../../assets/icons/novartis.svg";
import BingIcon from "../../assets/icons/prod-bing-logo.svg";

function LandingPage() {
  const navigate = useNavigate();
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const brandName = "Patient Experience Bank";
  const brandDescription =
    "Patients have been saying “nothing about us without us” for decades. Let us make patient-centered decisions today using their voice.";
  const environment = userInfo?.environment || "";
  const logoMap = {
    dev: "",
    qa: "",
    demo: "",
    prod_client_1: LillyIcon,
    prod_gild: GileadIcon,
    prod_aszn: AZIcon,
    prod_janj: JJIcon,
    prod_snfi: SanofiIcon,
    prod_nvsp: NovartisIcon,
    prod_bing: BingIcon
  };

  const logoMapStyle = {
    dev: { height:22 , marginRight: 10 ,verticalAlign :"super" , marginTop:-1 },
    prod_janj: { height:18 ,marginTop: 4 , marginRight: 10 },
    prod_gild: { marginTop: -22 , marginRight: 12 },
    prod_snfi: {height : 18 ,marginTop: 4 , marginRight: 10 },
    prod_aszn: { height:22 , marginRight: 10 ,verticalAlign :"super" , marginTop:-1 },
    prod_nvsp: { height:22 , marginRight: 10 ,verticalAlign :"super" , marginTop:-1 },
    prod_bing: { height:22 , marginRight: 10 ,verticalAlign :"super" , marginTop:2 },
  };

  const clientLogo = logoMap[environment] || "";
  const clientLogoStyle = logoMapStyle[environment];

  const cardData = [
    {
      id: "bank_of_standards",
      title: "Bank of Standards",
      description:
        "Explore survey-based patient insights from thousands of diverse patients globally using custom cohorts.",
      icon: <Icon1 style={{ width: 24, height: 24, marginRight: 8 }} />,
      tooltip:
        "Voice of global patients across 20 MM+ datapoints captured via surveys.",
      redirectionPath: "/explore",
    },
    {
      id: "bespoke_insights",
      title: `${environment == "prod_client_1"?"ELVIA":"PXB 3.0"}` ,
      description:
      `${environment == "prod_client_1"?
        "AI-enabled workflow automation to combine external Lilly (i.e., patients/sites) voices and insights with cross-industry quantitative standards."
        :"AI-enabled workflow automation to combine your unstructured patient/site voice data and ZS Bank of Standards insights."}`,
      icon: <Icon2 style={{ width: 24, height: 24, marginRight: 8 }} />,
      tooltip:
        "Voice of global patients through qualitative (transcripts, reports, notes) and quantitative (Patient experience survey data) insights",
      redirectionPath: "",
    },
  ];

  // Filter card data based on 'kural_visible'
  const visibleCards = userInfo?.kural_visible
    ? cardData
    : cardData.filter((card) => card.id !== "bespoke_insights");

  const navigateTo = (path) => {
    // console.log(path);
    if (path === "/explore") {
      navigate(path);
    } else {
      logOutFromPEB();
      // setTimeout(() => {
      //   window.open(process.env.REACT_APP_ENV_SWITCH_URL, "_self");
      // }, 1200);
      // window.open(process.env.REACT_APP_ENV_SWITCH_URL, "_self");
    }
  };
  const logOutFromPEB = async () => {
    const payload = {
      user_id: localStorage.getItem("user_id"),
      logout_from: "to_kural",
    };

    notification.info({
      key: "logout-progress",
      // message: "Switching app",
      description: "Please wait while we redirect",      
      icon: <LoadingOutlined spin />,
      duration: 0,
    });

    try {
      await logout(payload);
      window.open(process.env.REACT_APP_ENV_SWITCH_URL, "_self");
    } catch (error) {
      notification.error({
        key: "logout-progress",
        // message: "Switch failed",
        description: "Something went wrong. Please try again.",
        placement: "topRight",
        duration: 4,
      });
    }
  };

  return (
    <>
      <Row>
        <Col span={24} className="landing-header">
          <Row
            style={{
              width: "100%",
              height: "210px",
              backgroundImage: `url(${LandingPageHeader})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}>
            <Col span={12} style={{ paddingLeft: 32, top: "20%" }}>
              <span className="brand-name">{brandName}</span>
              <p className="brand-description">{brandDescription}</p>
            </Col>
            <Col
              span={12}
              style={{ paddingRight: 28, textAlign: "right", marginTop: 24 }}>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {clientLogo && (
                  <img
                    src={clientLogo}
                    alt={`${environment} logo`}
                    style={{ height: 72, ...clientLogoStyle }}
                  />
                )}
                {/* <Divider type="vertical" style={{ height: "24px", backgroundColor: "#ccc" }} /> */}
                <img
                  src={ZSLogo}
                  alt={`${environment} logo`}
                  style={{ height: 28 }}
                />
              </div>
            </Col>
          </Row>
        </Col>
        <div className="cards-div">
          <Row style={{ gap: 16 }}>
            {visibleCards.map((card, index) => (
               <div 
                key={index} 
                style={{ 
                  width: 480, 
                  height: 180, 
                }}>
                <Card
                  style={{
                    borderRadius: "1px",
                    borderColor: "#E6E6E6",
                    padding: 24,
                    display: "flex",
                    flexDirection: "column"
                  }}
                  hoverable
                  onClick={() => navigateTo(card?.redirectionPath)}>
                  <div style={{ display: "flex" }}>
                    <div> {card.icon}</div>
                    <div>
                      <span className="landing-card-header">
                        {card.title}{" "}
                        <Tooltip
                          title={card.tooltip}
                          overlayStyle={{ width: 300 }}>
                          <InfoCircleOutlined style={{ color: "#27A6A4" }} />
                        </Tooltip>
                      </span>
                      <br />
                      <p>{card.description}</p>
                    </div>
                  </div>
                  <ArrowRightOutlined
                    style={{ float: "right", color: "#27A6A4", marginBottom:'0px' }}
                  />
                </Card>
              </div>
            ))}
          </Row>
        </div>
      </Row>
    </>
  );
}

export default LandingPage;
